module.exports = __webpack_public_path__ + "static/media/licenta13.77ea12dd.png";